import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconNewspaper1"><Path d="M12 6.06235L6.40289 4.81434C4.52878 4.39647 2.75 5.82231 2.75 7.74244V16.0326C2.75 17.4379 3.7255 18.6549 5.09711 18.9607L12 20.4998M12 6.06235L17.5971 4.81434C19.4712 4.39647 21.25 5.82231 21.25 7.74244V16.0326C21.25 17.4379 20.2745 18.6549 18.9029 18.9607L12 20.4998M12 6.06235V20.4998" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconNewspaper1;
